import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import { FormatPrice } from 'utils/format';
import { connect } from 'react-redux';

import { getUserInfo } from 'redux/modules/shipper-order-form/selectors';

import { saveCost, saveCostLater } from 'redux/modules/shipper-order-new/effects';

import {
  getRecentlyCreatedShipperOrder,
  getIsSavingCost,
} from 'redux/modules/shipper-order-new/selectors';

import { Flexer, Modal, Button, Field, Spacer, Text } from '@ontruck/orc';
import { Loading } from 'components/Loading';

const t = {
  literal_1: 'The shipper will pay',
  literal_2: 'without VAT. How much will we pay the carrier?',
  save: 'Save cost',
  later: 'Introduce cost later',
  label: 'Cost without VAT',
};

class JourneyCostModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cost: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e, { value }) {
    this.setState({
      cost: value,
    });
  }

  handleSubmit() {
    const { saveCost } = this.props;

    saveCost({ cost: this.state.cost });
  }

  render() {
    const { onClose, userInfo, intl, shipperOrder, saveCostLater, isSaving } = this.props;

    const { cost } = this.state;

    if (!userInfo || !shipperOrder) {
      return null;
    }

    const { net_full_price } = shipperOrder;

    const { currency } = userInfo;
    const currencySymbol = intl.messages.currencies[currency];

    return (
      <Modal onClose={onClose} show={true} size="S" closeButton={false}>
        <Spacer mBottom="S">
          <Text display="block" weight="bold">
            {t.literal_1} {<FormatPrice currency={currency} value={net_full_price} />} {t.literal_2}
          </Text>
        </Spacer>
        <Spacer mBottom="S">
          <Flexer.Parent alignItems="center">
            <Flexer.Child mRight="S">
              <Field
                value={cost}
                label={t.label}
                width="M"
                asideRightText={currencySymbol}
                onChange={this.handleChange}
              />
            </Flexer.Child>
            <Flexer.Child>{isSaving && <Loading size={25} />}</Flexer.Child>
          </Flexer.Parent>
        </Spacer>
        <Spacer mBottom="S">
          <Button disabled={isSaving} fullWidth onClick={this.handleSubmit}>
            {t.save}
          </Button>
        </Spacer>
        <Button disabled={isSaving} fullWidth skin="secondary" ghost onClick={saveCostLater}>
          {t.later}
        </Button>
      </Modal>
    );
  }
}

JourneyCostModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  userInfo: PropTypes.string,
  shipperOrder: PropTypes.object,
  saveCost: PropTypes.func.isRequired,
  saveCostLater: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  isSaving: PropTypes.bool,
};

JourneyCostModal.defaultProps = {
  userInfo: {},
  shipperOrder: null,
  isSaving: false,
};

const actionCreators = {
  saveCost,
  saveCostLater,
};

export default injectIntl(
  connect(
    (state) => ({
      userInfo: getUserInfo(state),
      shipperOrder: getRecentlyCreatedShipperOrder(state),
      isSaving: getIsSavingCost(state),
    }),
    actionCreators
  )(JourneyCostModal)
);
